export default {

  _: "",
	A: "side streches (3-5)",
  B: "cactus twists (5 each side)",
  C: "forward fold twist (3 each side & hold)",
  D: "wide open cobras (5-8)",
  E: "prayer twist (both sides)",
  F: "cactus extensions (5-8 with weights)",

  G: "DD splits lo-lunge right (10)",
	H: "shoulder press lunge right (8)",
  I: "cactus twist lunge right (10)",
  J: "lunge spring-ups right (10)",
  K: "squat punches (10)",
  L: "gangster walks (2 laps)",

  G2: "DD splits lo-lunge left (10)",
  H2: "shoulder press lunge left (8)",
  I2: "cactus twist lunge left (10)",
  J2: "lunge spring-ups left (10)",
  M: "squat walk around (2 laps)",
  N: "squat crunches (10)",

  O: "side plank tap out right (10)",
  P: "pendulum lunge right (15)",
  Q: "fairy sweep right (15)",
  R: "blade runner right (15)",
  S: "cactus pyramid right (10)",
  T: "warrior 3 tucks right (10)",
  U: "genie squat (10)",
  V: "gold digger squats right (10)",

  O2: "side plank tap out left (10)",
  P2: "pendulum lunge left (15)",
  Q2: "fairy sweep left (15)",
  R2: "blade runner left (15)",
  S2: "cactus pyramid left (10)",
  T2: "warrior 3 tucks left (10)",
  W: "w star (10)",
  V2: "gold digger squats left (10)",

  X: "hippy kick right (10)",
  Y: "super crab right (15)",
  Z: "buddhi kicks right (15)",
  AA: "holy roller right (15)",
  BB: "bionic warrior right (10)",
  CC: "half moon curls right (10)",
  DD: "figure 4 cactus (10)",
  EE: "forward fold or cross crane",

  X2: "hippy kick left (10)",
  Y2: "super crab left (15)",
  Z2: "buddhi kicks left (15)",
  AA2: "holy roller left (15)",
  BB2: "bionic warrior left (10)",
  CC2: "half moon curls left (10)",
  FF: "figure 4 tricep (10)",
  EE2: "forward fold or cross crane",
  GG: "yoga squat",
  OO: "yoga squat variations",

  HH: "reverse table taps (10)",
  II: "--",
  JJ: "right elbow crunches (10)",
  JJ2: "left elbow crunches (10)",
  LL: "bridge pose",
  MM: "reclined pigeon right",
  NN: "reclined spinal twist right",
  MM2: "reclined pigeon left",
  NN2: "reclined spinal twist left",

  PP: "vinyasa",
  QQ: "savasana",

}



// WEBPACK FOOTER //
// ./src/directory.js